const { moment } = require('./date-util');
const _ = require('./_');
const objectUtil = require('./object-util');

function isMatchy(oldItem, newItem, options) {
  const flattenedOldItem = objectUtil.flatten(oldItem);
  const flattenedNewItem = objectUtil.flatten(newItem);

  const unifiedKeys = _.uniq(Object.keys(flattenedOldItem).concat(Object.keys(flattenedNewItem)));
  const isEveryFieldMatchy = unifiedKeys.every((unifiedKey) => {
    const oldVal = flattenedOldItem[unifiedKey];
    const newVal = flattenedNewItem[unifiedKey];

    if (oldVal === newVal) {
      return true;
    }
    if (options.falsyEqualsFalsy && !oldVal && !newVal && (oldVal !== 0) && (newVal !== 0)) {
      return true;
    }
    if (options.matchTypes) {
      if ((_.isBoolean(oldVal) && _.isString(newVal)) || (_.isString(oldVal) && _.isBoolean(newVal))) {
        const oldValTyped = _.isBoolean(oldVal) ? oldVal : (oldVal === 'true');
        const newValTyped = _.isBoolean(newVal) ? newVal : (newVal === 'true');
        return oldValTyped === newValTyped;
      }
      if ((_.isNumber(oldVal) && _.isString(newVal)) || (_.isString(oldVal) && _.isNumber(newVal))) {
        const oldValTyped = _.isNumber(oldVal) ? oldVal : Number(oldVal);
        const newValTyped = _.isNumber(newVal) ? newVal : Number(newVal);
        return oldValTyped === newValTyped;
      }
      if ((_.isDate(oldVal) && _.isString(newVal)) || (_.isString(oldVal) && _.isDate(newVal))) {
        const compareFormat = 'YYYY-MM-DDThh:mm:ss';
        const oldValTyped = moment(oldVal).format(compareFormat);
        const newValTyped = moment(newVal).format(compareFormat);
        return oldValTyped === newValTyped;
      }
    }
    return false;
  });

  return isEveryFieldMatchy;
}

module.exports = {
  isMatchy,
  getChanges(oldItems, newItems, itemToKeyMapping, options) {
    // options = {
    //   changeFields: an array of fields to check for changes... otherwise checks all values,
    //   falsyEqualsFalsy: allow '', null, undefined to be the same (note that 0 is not the same in this use),
    //   matchTypes: if comparing two primitives where 1 is a string and another a Boolean/Date/Number, it will convert to the same type
    // }
    const oldKeys = (oldItems || []).map(itemToKeyMapping);
    const newKeys = (newItems || []).map(itemToKeyMapping);

    const addedKeys = _.difference(newKeys, oldKeys);
    const removedKeys = _.difference(oldKeys, newKeys);
    const preservedKeys = _.intersection(oldKeys, newKeys);

    const addedItems = addedKeys.map(k => _.find(newItems, n => itemToKeyMapping(n) === k));
    const removedItems = removedKeys.map(k => _.find(oldItems, o => itemToKeyMapping(o) === k));
    const changedItems = [];
    preservedKeys.forEach((k) => {
      const oldItem = _.find(oldItems, o => itemToKeyMapping(o) === k);
      const newItem = _.find(newItems, n => itemToKeyMapping(n) === k);

      const oldItemSubset = (options && options.changeFields) ? objectUtil.pickMany(oldItem, options.changeFields) : oldItem;
      const newItemSubset = (options && options.changeFields) ? objectUtil.pickMany(newItem, options.changeFields) : newItem;

      if (!_.isEqual(oldItemSubset, newItemSubset)) {
        if (options && (options.matchTypes || options.falsyEqualsFalsy)) {
          if (!isMatchy(oldItemSubset, newItemSubset, options)) {
            changedItems.push(newItem);
          }
        } else {
          changedItems.push(newItem);
        }
      }
    });

    return {
      added: addedItems,
      removed: removedItems,
      changed: changedItems,
    };
  },

  convertFromCSV(potentialCSV, returnSingleItemAsString = false) {
    if (_.isString(potentialCSV)) {
      if (potentialCSV.includes(',')) {
        const tokens = potentialCSV.split(',');
        return tokens.map(t => t.trim());
      }
      if (!returnSingleItemAsString) {
        return [potentialCSV];
      }
    }
    return potentialCSV;
  },
};
